import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MsgLoadingService {

    protected data: BehaviorSubject<any> = new BehaviorSubject({});

    public data$ = this.data.asObservable();
   
    constructor(
    ){

    }

    setMessage(local, data){
        this.data.next({local:local, data: data});
    }

    getData(){
        return this.data.getValue();
    }

}